import { Box, Grid } from "@mui/material";

import Section from "./Section";
import { employeeDashboardOrder, sectionOrder } from "../utils/consts";

export interface ISectionsProps {
  readonly sections: any;
}

type EmployeeDashboardOrderKey = keyof typeof employeeDashboardOrder;

export function sortSectionsByOrder(
  sections: { section: string; dashboards: any[] }[]
): { section: string; dashboards: any[] }[] {
  return sections.sort((a, b) => {
    const idxA = sectionOrder.indexOf(a.section);
    const idxB = sectionOrder.indexOf(b.section);
    return (
      (idxA === -1 ? sectionOrder.length : idxA) -
      (idxB === -1 ? sectionOrder.length : idxB)
    );
  });
}

export default function Sections({ sections }: ISectionsProps) {
  const sectionArray: { section: string; dashboards: any[] }[] = Object.keys(
    sections
  ).map((key) => ({
    section: key,
    dashboards: sections[key],
  }));

  const orderedSections = sortSectionsByOrder(sectionArray).map(
    (sectionObj) => {
      if (sectionObj.section === "Employee Dashboard") {
        return {
          ...sectionObj,
          dashboards: [...sectionObj.dashboards].sort((a, b) => {
            const orderA =
              employeeDashboardOrder[a.title as EmployeeDashboardOrderKey] ??
              999;
            const orderB =
              employeeDashboardOrder[b.title as EmployeeDashboardOrderKey] ??
              999;
            return orderA - orderB;
          }),
        };
      }
      return sectionObj;
    }
  );

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2} padding={2} sx={{ flexGrow: 1 }}>
        {orderedSections.map((sectionObj) => (
          <Grid
            key={sectionObj.section}
            size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}
          >
            <Section
              key={sectionObj.section}
              section={sectionObj.section}
              dashboards={sectionObj.dashboards}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
